// extracted by mini-css-extract-plugin
export default {"sec_tabs":"Tabs_sec_tabs__wd4dt","tab":"Tabs_tab__+IheG","active":"Tabs_active__3REqk"};